module.exports = __webpack_public_path__ + "img/upload.a1746312.svg";